export default {
  //Добавляет недостаяющие ключи в Json поле по заданной схеме
  handle_json_field(json_field, init_json_schema) {
    if (json_field === null) {
      return init_json_schema;
    }
    if (Array.isArray(json_field) && json_field.length === 0) {
      json_field = {};
    }

    for (var key in init_json_schema) {

      if (typeof init_json_schema[key] === 'boolean') {
        json_field[key] = json_field[key] ?? false;
        continue;
      }
      if (typeof init_json_schema[key] === 'string') {
        json_field[key] = json_field[key] ?? '';
        continue;
      }
      if (init_json_schema[key] instanceof Array) {
        json_field[key] = !json_field[key] ? [] : json_field[key];
      }
    }
    return json_field;
  },

  //Заменяем ключи вида project_data на projectData
  replaceKeys(obj) {
    if (typeof obj === 'object') {
      for (let key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key)) {
          if (key.includes('_')) {
            const newKey = key.replace(/_./g, match => match.charAt(1).toUpperCase());
            //console.log(key, newKey, obj[key]);
            //Object.assign(obj, { [newKey]: obj[key] });
            obj[newKey] = obj[key];
            delete obj[key];
          }
        }
      }
    }
    return obj;
  }
}